export default __webpack_public_path__ + "static/media/weather1.a2a93e19.jfif";